import React, { useState, useContext } from "react";
import { useActor } from "@xstate/react";
import TextInput, { isValidTextInput } from "../TextInput";
import { Button } from "../SignUpButton";
import { Loader } from "@pushpress/shared-components";
import {
  useRevenueHero,
  SignupFlowFormData,
} from "../../../../hooks/useRevenueHero";
import { env } from "../../../../env";
import HubspotContext from "../../../../context/hubspot";
import { getRevenueHeroFormData } from "../../utils";
import { useSignUpMachine } from "../../context/SignUpMachineContext";
import { SignUpFormField } from "../../constants/signup-form-field.enum";
import { TextInputType } from "../../constants/signup.types";

const ContactInfoStep: React.FC = () => {
  const machine = useSignUpMachine();
  const [state, send] = useActor(machine);
  const { formData } = state.context;

  const [isLoading, setIsLoading] = useState(false);
  const { showScheduler } = useRevenueHero(env.REVENUE_HERO_SAF_ROUTER_ID);
  const { identifyHubspotUser } = useContext(HubspotContext);

  const fields = [
    {
      id: SignUpFormField.Email,
      inputType: "email",
      label: "Email",
      required: true,
      disabled: true,
    },
    {
      id: SignUpFormField.FirstName,
      inputType: "text",
      label: "First Name",
      required: true,
    },
    {
      id: SignUpFormField.LastName,
      inputType: "text",
      label: "Last Name",
      required: true,
    },
    {
      id: SignUpFormField.Phone,
      inputType: "phone",
      label: "Phone Number",
      required: true,
    },
    {
      id: SignUpFormField.Url,
      inputType: "url",
      label: "Gym Website (if you have one)",
      required: false,
    },
  ];

  const handleChange = (fieldId: string, value: any) => {
    send({
      type: "UPDATE_FORM",
      data: { [fieldId]: value },
    });
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    const revenueHeroFormData = getRevenueHeroFormData(formData);

    identifyHubspotUser(
      revenueHeroFormData.email,
      revenueHeroFormData.firstName,
      revenueHeroFormData.lastName,
    );

    try {
      await showScheduler<SignupFlowFormData>(revenueHeroFormData);
    } catch (error) {
      console.error("Revenue Hero submission failed:", error);
    }
  };

  const canProceed = fields.every((field) => {
    if (!field.required) return true;
    return isValidTextInput(
      formData[field.id] as string,
      field.inputType as TextInputType,
    );
  });

  return (
    <>
      <div className="tw-flex tw-flex-col tw-items-center tw-space-y-1 tw-text-center">
        <h2 className="tw-text-xl">Contact information</h2>
      </div>
      <div className="tw-space-y-4">
        {fields.map((field) => (
          <TextInput
            key={field.id}
            id={field.id}
            value={formData[field.id] as string}
            onChange={(value) => handleChange(field.id, value)}
            inputType={field.inputType as TextInputType}
            label={field.label}
            required={field.required}
            disabled={isLoading || field.disabled}
          />
        ))}
      </div>
      <div className="tw-flex tw-justify-between tw-items-center">
        <Button
          onClick={handleSubmit}
          disabled={!canProceed || isLoading}
          size="fat"
          className="tw-uppercase tw-tracking-widest tw-w-full tw-flex tw-py-4 tw-items-center tw-gap-2 tw-text-white"
        >
          {isLoading ? <Loader color="white" /> : <span>Next</span>}
        </Button>
      </div>
    </>
  );
};

export default ContactInfoStep;
